import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import type { Sharer } from 'src/app/pages/petitionGamma/details/shared/types';

import {
	GammaPetitionDetailsPageSharerInfo,
	type GammaPetitionDetailsPageSharerInfoQuery,
	type GammaPetitionDetailsPageSharerInfoQueryVariables,
} from './sharer.graphql';

export async function getSharer(id: string, { gql: { fetch } }: UtilityContext): Promise<Sharer | undefined> {
	const { data } = await fetch<
		GammaPetitionDetailsPageSharerInfoQuery,
		GammaPetitionDetailsPageSharerInfoQueryVariables
	>({
		query: GammaPetitionDetailsPageSharerInfo,
		variables: { id },
		rejectOnError: false,
	});
	return data?.user || undefined;
}
